import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4f4d69d8&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=4f4d69d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d69d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4d69d8')) {
      api.createRecord('4f4d69d8', component.options)
    } else {
      api.reload('4f4d69d8', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4f4d69d8&scoped=true&", function () {
      api.rerender('4f4d69d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/adm/Index.vue"
export default component.exports